import {PageLink} from '../../_metronic/layout/core'
import {Navigation} from '../../components/Navigation'
import InquiresAll from './layouts/InquiresAll'
import SalesRepReport from './layouts/SalesRepReport'
import ProductReport from './layouts/ProductReport'
import PurchaserReport from './layouts/PurchaserReport'

const InquiresPageBreadCrumbs: Array<PageLink> = [
  {
    title: 'Products',
    path: '/products/all-products',
    isSeparator: false,
    isActive: false,
  },
]

function InquiresPage() {
  return (
    <Navigation
      baseUrl='/products/inquiries'
      breadcrumbs={InquiresPageBreadCrumbs}
      disableSearchParams={true}
      pageTitle='Inquires'
      navigationData={[
        {
          key: 'all-inquiries',
          label: 'All Inquiries',
          component: <InquiresAll />,
        },
        {
          key: 'archived',
          label: 'Archived',
          component: <InquiresAll />,
        },
        {
          key: 'sales-rep-report',
          label: 'Sales Rep Report',
          component: <SalesRepReport />,
        },
        {
          key: 'purchaser-report',
          label: 'Purchaser Report',
          component: <PurchaserReport />,
        },
        {
          key: 'product-report',
          label: 'Product Report',
          component: <ProductReport />,
        },
      ]}
    />
  )
}

export default InquiresPage
